<template>
  <div class="text__center one-request--change tile">
    <p class="text__bold">Add Existing Service</p>
    <ul class="change-list text__left">
      <li class="change-list--item">
        Add a service to
        <strong>this</strong> request if it is not present
      </li>
      <li class="change-list--item">
        To mark this service active for future requests visit
        <router-link to="/services">here</router-link>
      </li>
    </ul>
    <p v-if="getUnusedServices.length === 0">All Services Used</p>
    <div v-else class="change-form flex__center">
      <select name="add" v-model="service">
        <option
          v-for="service in getUnusedServices"
          :key="service._id"
          :value="service"
        >{{ service.name }}</option>
      </select>
      <button class="btn btn__small btn__green" @click="addService">Add</button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: ["active", "type"],
  data() {
    return {
      service: null
    };
  },
  computed: {
    ...mapGetters(["getServices"]),
    getActiveServices() {
      return this.active.services.filter(service => {
        return service.active;
      });
    },
    getUnusedServices() {
      // pulls all services applicable to opt-out requests, then removes any which are already active on this requests
      // adds inactive services on this request (to cover any which have been deleted) then removes any duplicates
      const newServices = this.getServices
        .filter(service => {
          return service.type === this.type.url;
        })
        .filter(service => {
          return !this.getActiveServices.find(active => {
            return active.name === service.name;
          });
        });
      newServices.push(
        ...this.active.services.filter(service => !service.active)
      );
      const tidyServices = newServices.map(service => {
        return JSON.stringify({
          name: service.name,
          request_type: service.type ? service.type : service.request_type,
          active: true
        });
      });
      return [...new Set(tidyServices)].map(service => {
        return JSON.parse(service);
      });
    }
  },
  methods: {
    async addService() {
      if (!this.service) {
        return this.flash("Add error: A service must be selected", "error");
      }
      // check if service is already present on active
      const servicePresent = this.active.services.find(active => {
        return active.name === this.service.name;
      });
      if (servicePresent) {
        const updatedService = {
          ...servicePresent,
          active: true
        };
        await this.$store.dispatch(
          `${this.type.namespace}/startUpdateRequest`,
          updatedService
        );
        this.service = null;
      } else {
        // post to api with service information
        const newService = {
          name: this.service.name,
          is_complete: false,
          request_id: this.active._id,
          request_type: this.service.type
            ? this.service.type
            : this.service.request_type,
          active: true
        };
        await this.$store.dispatch(
          `${this.type.namespace}/addRequestService`,
          newService
        );
        this.service = null;
      }
    }
  }
};
</script>

<style scoped>
</style>